import React from 'react';
import doc1 from '../assets/documents.v2/documento_identidad.png';
import doc2 from '../assets/documents.v2/denuncia_policial.png';
import doc3 from '../assets/documents.v2/sustento_de_bloqueo.png';
import doc4 from '../assets/documents.v2/movimientos_no_reconocidos.png';
import doc5 from '../assets/documents.v2/duplicado_por_documentos.png';
import doc6 from '../assets/documents.v2/gasto_por_hospitalizacion.png';

const FilesUploadingProps = {
  listFiles: [
    {
      title: 'Documento de identidad',
      typeFile: 'DOC-IDENTIDAD',
      description: (
        <>
          <p>Foto o imagen de tu DNI, CE, Pasaporte por ambos lados.</p>
        </>
      ),
      id: '1',
      btnAttach: 'ADJUNTAR',
      btnDelete: 'ELIMINAR',
      docUrl: doc1,
    },
    {
      title: 'Denuncia policial',
      typeFile: 'DENUNCIA-POLICIAL',
      description: (
        <>
          <p>Una foto o imagen de la copia de la denuncia policial.</p>
        </>
      ),
      id: '2',
      btnAttach: 'ADJUNTAR',
      btnDelete: 'ELIMINAR',
      docUrl: doc2,
    },
    {
      title: 'Sustento del bloqueo',
      typeFile: 'COPIA-BLOQUEO',
      description: (
        <>
          <p>
            Una foto o imagen de la constancia que te dieron al bloquear tu
            tarjeta.
          </p>
          {/* <a
            href="https://www.bbva.pe/content/dam/public-web/peru/documents/personas/seguros/seguro-de-bienes/seguro-de-proteccion-de-tarjeta/siniestros/Ejm-de-sustento-de-bloqueo.pdf"
            className="dowload-file"
            download="filename"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon name="download" />
            <p>DESCARGAR EJEMPLO</p>
          </a> */}
        </>
      ),
      id: '3',
      btnAttach: 'ADJUNTAR',
      btnDelete: 'ELIMINAR',
      docUrl: doc3,
    },
    {
      title: 'Movimiento bancarios reclamados',
      typeFile: 'COPIA-MOVBANCARIOS',
      description: (
        <>
          <p>
            Una foto o imagen donde figuren los movimientos que no reconoces.
          </p>
          {/* <a
            href="https://www.bbva.pe/content/dam/public-web/peru/documents/personas/seguros/seguro-de-bienes/seguro-de-proteccion-de-tarjeta/siniestros/Ejm-de-movimientos-no-reconicidos.pdf"
            className="dowload-file"
            download="filename"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon name="download" />
            <p>DESCARGAR EJEMPLO</p>
          </a> */}
        </>
      ),
      id: '4',
      btnAttach: 'ADJUNTAR',
      btnDelete: 'ELIMINAR',
      docUrl: doc4,
    },
    {
      title: 'Sustento de gastos por duplicado de documentos',
      typeFile: 'GASTOS-DUPLICADOSDOC',
      description: (
        <>
          <p>
            Una foto o imagen donde figuren los comprobantes de gastos por
            duplicados (DNI, pasaporte, CE, brevete, chapas o llaves){' '}
          </p>
        </>
      ),
      id: '5',
      btnAttach: 'ADJUNTAR',
      btnDelete: 'ELIMINAR',
      docUrl: doc5,
    },
    {
      title: 'Sustento de gastos por hospitalización',
      typeFile: 'GASTOS-HOSPITALIZACIÓN',
      description: (
        <>
          <p>
            Una foto o imagen de donde figuren los comprobantes de gastos por
            hospitalización.
          </p>
        </>
      ),
      id: '6',
      btnAttach: 'ADJUNTAR',
      btnDelete: 'ELIMINAR',
      docUrl: doc6,
    },
  ],
};

export default FilesUploadingProps;
